import { Injectable } from '@angular/core';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Beacon?: (method: string, ...args: unknown[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class BeaconService {
  public init(): void {
    window.Beacon?.('config', {
      color: '#48b870',
      docsEnabled: true,
      messagingEnabled: true,
      enableFabAnimation: true,
    });
  }

  public identify(name: string, email: string): void {
    window.Beacon?.('identify', { name, email });
  }

  public reset(): void {
    window.Beacon?.('reset');
  }
}
